import { HangoutState } from '../../state/HangoutState.js';
import { storage } from '../../../utils/storage.js';

export const toIdString = (value) => (value ?? '').toString();

export const getConfiguredActiveCharacters = async () => {
    const hangoutConfig = storage.get('currentHangoutConfig');
    if (Array.isArray(hangoutConfig?.allCharacters)) {
        return hangoutConfig.allCharacters;
    }

    const hangoutState = HangoutState.getInstance();
    const currentSession = hangoutState.getCurrentSession();
    if (currentSession?.allCharacters?.length) {
        return currentSession.allCharacters;
    }

    return [];
};

export const getActiveCharacterForSlot = (activeCharacters, slotIndex, characterId) => {
    if (!Array.isArray(activeCharacters) || activeCharacters.length === 0) return null;

    const normalizedId = characterId ? toIdString(characterId) : null;
    const slotCharacter = activeCharacters[slotIndex];

    if (slotCharacter && (!normalizedId || toIdString(slotCharacter.id) === normalizedId)) {
        return slotCharacter;
    }

    if (!normalizedId) return null;
    return activeCharacters.find(char => toIdString(char?.id) === normalizedId) || null;
};

export async function getEnhancedCharacterData(characterId, allCharacters) {
    let selectedCharacter = allCharacters.find(char => char.id.toString() === characterId);

    try {
        const { HangoutService } = await import('../../services/HangoutService.js');
        const hangoutService = HangoutService.getInstance();
        const characterDetails = await hangoutService.getCharacterDetails(characterId);

        if (characterDetails && characterDetails.gender !== undefined) {
            selectedCharacter = { ...selectedCharacter, ...characterDetails };
        } else {
            console.warn(`Settings Modal: No gender info available from HangoutService for character ${characterId}, using fallback`);
        }
    } catch (error) {
        console.warn(`Settings Modal: Error fetching character details from HangoutService for character ${characterId}:`, error);
    }

    return selectedCharacter;
}

export const CREW_MAP = [
    { charSelect: 'crew-char-1-settings', roleSelect: 'crew-role-1-settings', preview: 'character-1-preview-settings' },
    { charSelect: 'crew-char-2-settings', roleSelect: 'crew-role-2-settings', preview: 'character-2-preview-settings' },
    { charSelect: 'crew-char-3-settings', roleSelect: 'crew-role-3-settings', preview: 'character-3-preview-settings' }
];
